import React, { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import AuroraBackground from './dashboard/AuroraBackground';
import PageHeader from './PageHeader';

// The shared Aurora page frame: the drifting aurora canvas, a glowing icon chip,
// a gradient title (+ optional subtitle), an optional action slot, and the page
// body beneath. This is the canonical skin every full-page screen wears — wrap a
// new page in it (the way DocumentGridShell / DocumentFormScaffold do inline) so
// "build aurora going forward" means one import, not a copy of the boilerplate.

interface AuroraPageShellProps {
  title: string;
  // a rendered icon element (BrandIcon, a Chakra icon, or a react-icon); the chip
  // tints it brand-green via currentColor, so pass color="currentColor" where it applies
  icon?: ReactNode;
  subtitle?: ReactNode;
  // right-aligned header content (e.g. an ADD button)
  actions?: ReactNode;
  children: ReactNode;
}

const AuroraPageShell: React.FC<AuroraPageShellProps> = ({
  title, icon, subtitle, actions, children,
}) => (
  <Box
    position="relative"
    // item 732 (Chad) — the shell bled left/right/bottom but NOT the top, leaving a bare strip
    // (the content wrapper's pt + HeroGlow) above the aurora canvas → a visible "two backgrounds"
    // seam. Pull up to cancel that pt ({base:3, md:4} on the SidebarWithHeader content column) so
    // the aurora field is continuous from the top. Keep an inner pt for breathing room.
    mx={{ base: -4, md: -10 }}
    mt={{ base: -3, md: -4 }}
    mb={{ base: -4, md: -8 }}
    px={{ base: 4, md: 10 }}
    pt={{ base: 3, md: 4 }}
    pb={{ base: 6, md: 8 }}
    minH={{ base: 'auto', lg: 'calc(100vh - 160px)' }} // item 1063
  >
    <AuroraBackground />
    <Box position="relative" zIndex={1}>
      {/* item 353 — pinned below the dashboard on every shell page */}
      <PageHeader sticky icon={icon} title={title} subtitle={subtitle} actions={actions} />
      {children}
    </Box>
  </Box>
);

AuroraPageShell.defaultProps = {
  icon: undefined,
  subtitle: undefined,
  actions: undefined,
};

export default AuroraPageShell;
